import { buildModule } from '../utils';

import detail from './detail';
import list from './list';
import distribution from './distribution';
// import customFields from './custom-fields';

export default buildModule()
	.withSubmodules({
		detail,
		list,
		distribution,
		// customFields,
	});
